import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import momenttz from '../../../component/helpers/momenttz';
import { IoMdArrowForward } from "react-icons/io"
import { useTranslation } from 'react-i18next'

const TreeVehicleNode = (props) => {
	const { device, activeTreeItem, onTreeDeviceClick } = props
	const { device_id, vehicle_name, online, ignition, last_disconnected_ts, status, vehiclesType, name, beacon_id } = device;
	const { device_id: activeDeviceId, beacon_id: activeBeaconId } = activeTreeItem || {};
	const { t } = useTranslation();

	const getStatusTime = () => {
		if (status === 'offline' && last_disconnected_ts) {
			return <div className="status-time">{`${t('homePage.treeVehicleNode.since')} ${momenttz(last_disconnected_ts + (last_disconnected_ts.toString().includes('GMT') ? '' : '+00')).format('MM/DD/YY')}`}</div>
		}

		if (status === 'parked' && ignition && ignition.ts) {
			const parkingDurationSecs = moment.utc().diff(moment.utc(ignition.ts), 'seconds')
			const subTitle = parkingDurationSecs < 60 ? t('homePage.treeVehicleNode.justNow') : moment.duration(parkingDurationSecs, 'seconds').format('d[D] h[H] m[M]', { trim: 'both' })
			return (
				<div className="status-time">
					{`${t('homePage.treeVehicleNode.parked')} ${subTitle}`}
				</div>
			)
		}
	}

	const isActiveDevice = device_id === activeDeviceId;
	const isActiveEquipment = beacon_id === activeBeaconId;
	const isActive = vehiclesType === 'equipment' ? isActiveEquipment : isActiveDevice;

	// FWSD-4314 - If device does not receive GPS from device and ignition is Off more 24 hours (1440 mins) then display Online status.
	// Device stopped receive GPS, broken antena or something, and FileServer does not know when ignition is On.
	let onlineStatus = 'parking'
	if (!online) {
		onlineStatus = 'offline'
	} else {
		if ((ignition && ignition.state)) {
			onlineStatus = 'online'
		}
	}
	const isOnline = onlineStatus === 'online'
	const isParked = onlineStatus === 'parking' //online && (!ignition || !ignition.state)

	return (
		<div
			className={`tree-node-container ${isActive && 'active'}`}
			onClick={() => onTreeDeviceClick(device)}
			tabIndex={0}
			role="button"
		>
			<div className="tree-node-header category-item flex-item thin">
				<div className="status-row">
					<div className={`icon ${vehiclesType === 'equipment' ? 'non-vehicle' : status.replace(' ', '_')}`}></div>
					<div className="vehicle-name">{vehiclesType === 'equipment' ? (name || beacon_id) : (vehicle_name || device_id)}</div>

				</div>
				{getStatusTime()}
				<IoMdArrowForward />
			</div>
		</div>
	)
}

TreeVehicleNode.propTypes = {
	vehicle_name: PropTypes.string,
	onTreeDeviceClick: PropTypes.func.isRequired,
};

TreeVehicleNode.defaultProps = {
	vehicle_name: '',
}

export default TreeVehicleNode;
